import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'src/web/components/Marketing/Button';
import {
  OL_COLOUR_BLACK_10,
  OL_COLOUR_BLACK_55,
  OL_COLOUR_BLACK_90,
  OL_COLOUR_NAVY_BABY,
} from 'src/web/components/Style/colours';

export const DummyCheckbox = styled('input')({
  '&[type="checkbox"]': {
    margin: 0,
    transform: 'scale(1.1)',
    marginRight: '8px',
  },

  '@supports (zoom: 1.4)': {
    '&[type="checkbox"]': {
      transform: 'none',
      zoom: 1.4,
    },
  },
});

const paddedFlexStyle = {
  display: 'flex',
  alignItems: 'center',
  padding: '14px 16px',
};

const fontStyle = {
  fontSize: '14px',
  fontFamily: 'Open Sans',
};

export const StyledOption = styled('div')({
  ...paddedFlexStyle,
  color: OL_COLOUR_BLACK_90,
  ...fontStyle,
  lineHeight: '20px',
});

export const MenuListWrapper = styled('div')({
  height: 'auto',
});

export const MenuListActionBar = styled('div')({
  ...paddedFlexStyle,

  '.separator': {
    margin: '0 10px',
    color: OL_COLOUR_BLACK_55,
  },

  '&.topBar': {
    borderBottom: `1px solid ${OL_COLOUR_BLACK_10}`,
  },

  '&.bottomBar': {
    borderTop: `1px solid ${OL_COLOUR_BLACK_10}`,
  },
});

export const BulkActionButton = styled('button')({
  background: 'none',
  border: 'none',
  padding: '0',
  margin: '0',
  ...fontStyle,
  fontWeight: 600,
  textDecoration: 'underline',
  color: OL_COLOUR_NAVY_BABY,
});

export const ValueContainerStatus = styled('div')({
  ...fontStyle,
});

export const OptionWrapper = styled('div')(
  ({ isSelected }: { isSelected: boolean }) => ({
    background: isSelected ? 'red' : 'transparent',
  })
);

export const StyledDropdownIcon = styled(FontAwesomeIcon)({
  color: OL_COLOUR_BLACK_90,
});

export const StyledButton = styled(Button)({
  padding: '8px 27px',
  marginRight: '16px',
});
